<script setup lang="ts">
useHead({
  meta: [{ name: 'viewport', content: 'width=device-width, initial-scale=1' }],
  script: [
    {
      key: 'jgi-viewport-heal',
      // Inline paling awal: selalu set viewport aman + bersihkan class HP macet
      children: `(function(){try{document.querySelectorAll('meta[name="viewport"]').forEach(function(m){m.setAttribute('content','width=device-width, initial-scale=1');});var r=document.documentElement;r.classList.remove('jgi-device-hp','jgi-device-tablet');r.style.removeProperty('--jgi-device-w');if(localStorage.getItem('jgi_device_preview_heal_v13')!=='1'){localStorage.setItem('jgi_device_preview','desktop');localStorage.setItem('jgi_device_preview_heal_v13','1');}}catch(e){}})();`,
      tagPosition: 'head',
    },
  ],
});
</script>

<template>
  <NuxtLoadingIndicator color="#0f766e" :height="3" />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <ClientOnly>
    <AppSwitchOverlay />
  </ClientOnly>
</template>
